import type {
  FloorAssemblyInteriorFinishLayerOperator,
  FloorAssemblyOperationType,
  FloorAssemblyExteriorFinishLayerOperator,
  FloorAssemblyDynamicFinishLayerOperator,
  SourceEntityData,
} from "building-types/floors/floorFinishTypes";
import { FloorFinishType } from "building-types/floors/floorFinishTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type {
  ExteriorFloorMaterialOverride,
  InteriorFloorMaterialOverride,
} from "building-types/settings/floorMaterialSettings";
import type { PolyLine2 } from "geom/polyLine2Types";

export function floorAssemblyInteriorFinishLayerOperatorNew(
  finishOperation: FloorAssemblyOperationType,
  finishMaterial: InteriorFloorMaterialOverride,
  srcHandle?: DocEntityHandle,
  finishPerimeter?: PolyLine2,
  isFloorThreshold?: boolean,
): FloorAssemblyInteriorFinishLayerOperator & SourceEntityData {
  return {
    finishType: FloorFinishType.INTERIOR,
    operationType: finishOperation,
    finishMaterial,
    finishPerimeter,
    isFloorThreshold,
    // Conditional: the doc schema omits srcHandle, and strict field validation on persisted
    // FLOOR_FINISH entities flags even an undefined value.
    ...(srcHandle && { srcHandle }),
  };
}

export function floorAssemblyExteriorFinishLayerOperatorNew(
  finishOperation: FloorAssemblyOperationType,
  finishMaterial: ExteriorFloorMaterialOverride,
  srcHandle?: DocEntityHandle,
  finishPerimeter?: PolyLine2,
  isFloorThreshold?: boolean,
): FloorAssemblyExteriorFinishLayerOperator & SourceEntityData {
  return {
    finishType: FloorFinishType.EXTERIOR,
    operationType: finishOperation,
    finishMaterial,
    ...(srcHandle && { srcHandle }),
    finishPerimeter,
    isFloorThreshold,
  };
}

export function floorAssemblyDynamicFinishLayerOperatorNew(
  finishOperation: FloorAssemblyOperationType,
  srcHandle?: DocEntityHandle,
  finishPerimeter?: PolyLine2,
  isFloorThreshold?: boolean,
): FloorAssemblyDynamicFinishLayerOperator & SourceEntityData {
  return {
    finishType: FloorFinishType.DYNAMIC,
    operationType: finishOperation,
    ...(srcHandle && { srcHandle }),
    finishPerimeter,
    isFloorThreshold,
  };
}
